import {  Col, Container, Row, Carousel } from "react-bootstrap";
import { carouselItems } from './projectData';
import BallSaperator from './BallSaperator';

export default function Testimonial() {
  
  return (
    <div className="p-1 Carousel_wrapper">
          <BallSaperator />

      <Container>
        
        <Row >
          <Col lg={10} className="testimonial_section rounded-4 mx-auto">
        <h2>My Testimonials</h2>
            <Carousel indicators={true} controls={false} interval={3000}>

              {carouselItems.map((item, id) => (
                <Carousel.Item key={id}>

                  <div className="testimonial_card">

                    {/* Header */}
                    <div className="testimonial_header">
                      <img
                        src={item.image}
                        alt="avatar"
                        className="testimonial_avatar"
                      />

                      <div>
                        <h6>{item.name}</h6>
                        <span>{item.role}</span>
                      </div>
                    </div>

                    {/* Text */}
                    <p className="testimonial_text">
                      “{item.text}”
                    </p>

                  </div>

                </Carousel.Item>
              ))}

            </Carousel>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
